import { createSelector, createFeatureSelector } from '@ngrx/store';
import { ProductState } from './individual-all-product.reducer';
import { AppState } from '../app.state';

// Feature selector for the ProductState
export const selectProductState = createFeatureSelector<AppState, ProductState>('individualProducts');



// Selector for filtered products
export const selectIndividualProducts = createSelector(
  selectProductState,
  (state: ProductState) => state.individualProducts
);

// Selector for loading state
export const selectIndividualProductsLoading = createSelector(
  selectProductState,
  (state: ProductState) => state.loading
);

// Selector for error state
export const selectError = createSelector(
  selectProductState,
  (state: ProductState) => state.error
);
